import { POST } from '@/shared/api/requests';
import type { SignupRequest, SignupResponse } from '../types';

/**
 * Sign up a new user
 * @param data - Signup form data
 * @returns Promise with signup response
 */
export const signup = async (data: SignupRequest): Promise<SignupResponse> => {
  const response = await POST<SignupRequest>('/users/auth/signup/', data);
  return response.data as SignupResponse;
};

/**
 * Resend verification email
 * @param email - Email address to resend verification to
 * @returns Promise with response message
 */
export const resendVerificationEmail = async (email: string): Promise<{ message: string }> => {
  const response = await POST<{ email: string }>('/users/auth/resend-verification/', { email });
  return response.data as { message: string };
};

